// Generated by CoffeeScript 2.7.0
var Rating;

import Base from './base.js';

export default Rating = (function() {
  class Rating extends Base {
    getDisappearedFieldIdsOnInit() {
      return _.pluck(this.logic_rule, 'field_ids');
    }

  };

  Rating.setAttributes(['maximum']);

  return Rating;

}).call(this);
